import { Fragment, useRef, useEffect, useState } from "react";
import Banner from "./components/Banner";
import About from "./components/About";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import VariableProximity from "../../components/VariableProximity";
import './Home.scss';

function Home() {
    const containerRef: any = useRef(null);
    const proximityRef = useRef<HTMLDivElement>(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const el = proximityRef.current;
        if (!el) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.6 }
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    return (
        <Fragment>
            <div id="banner">
                <Banner />
            </div>
            <div id="about">
                <About />
            </div>
            <div id="projects">
                <Projects />
            </div>

            <div className="bg-section">
                <div className="bg-content">
                    <div
                        ref={(node) => {
                            containerRef.current = node;
                            (proximityRef as any).current = node;
                        }}
                        className={`v-proximity-outer${visible ? " v-proximity-visible" : ""}`}
                    >
                        <VariableProximity
                            className="v-proximity"
                            label={'Crafting Meaningful Digital Experiences'}
                            fromFontVariationSettings="'wght' 400, 'opsz' 40"
                            toFontVariationSettings="'wght' 1000, 'opsz' 80"
                            containerRef={containerRef}
                            radius={100}
                            falloff='linear'
                        />
                    </div>
                </div>
            </div>

            <div id="contact">
                <Contact />
            </div>
        </Fragment>
    )
}

export default Home;